import { render, staticRenderFns } from "./CryptomatLimitsTable.vue?vue&type=template&id=e45cd2d6&scoped=true&"
import script from "./CryptomatLimitsTable.vue?vue&type=script&lang=js&"
export * from "./CryptomatLimitsTable.vue?vue&type=script&lang=js&"
import style0 from "./CryptomatLimitsTable.vue?vue&type=style&index=0&id=e45cd2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45cd2d6",
  null
  
)

export default component.exports